import { render } from "./EditInquiryType.vue?vue&type=template&id=1c402bce&scoped=true"
import script from "./EditInquiryType.vue?vue&type=script&lang=js"
export * from "./EditInquiryType.vue?vue&type=script&lang=js"

import "./EditInquiryType.vue?vue&type=style&index=0&id=1c402bce&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c402bce"]])

export default __exports__